import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';


@Component({
  components: {


  },
})
export default class Toggle extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;


  @Prop()
  name: string;
  @Prop()
  value: boolean = false;




  valueChanged() {


    this.$emit('toggleChanged',this.value);
  }


  created() {

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);



  }


  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }
}



// WEBPACK FOOTER //
// ./src/components/parts/Toggle.ts